import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService, SmBaseService, OperationResult } from '../../core';
import { Observable } from 'rxjs';

@Injectable()
export class ExportBaseService<ESM extends ExportSettingsModel> extends SmBaseService {
	constructor(http: HttpService, ctrl: string) {
		super(http, ctrl);
	}

	get(): Observable<ExportTemplateListModel[]> {
		return this._getAs<ExportTemplateListModel[]>();
	}

	getForAutomatic(): Observable<ExportTemplateListModel[]> {
		return this._getAs<ExportTemplateListModel[]>('forAutomatic');
	}

	getById(id: number): Observable<ExportTemplateModel<ESM>> {
		return this._getAs<ExportTemplateModel<ESM>>(id);
	}

	post(model: ExportTemplateModel<ESM>): Observable<ExportTemplateModel<ESM>> {
		return this._postAs<ExportTemplateModel<ESM>>('', model);
	}

	put(id: number, model: ExportTemplateModel<ESM>): Observable<ExportTemplateModel<ESM>> {
		return this._putAs<ExportTemplateModel<ESM>>(id, model);
	}

	postOrPut(model: ExportTemplateModel<ESM>): Observable<ExportTemplateModel<ESM>> {
		return (model.id < 1) ? this.post(model) : this.put(model.id, model);
	}

	export(model: ExportTemplateModel<ESM>): Observable<string> {
		return this._postAs<string>('export', model);
	}

	delete(id: number): Observable<Response> {
		return this._delete(id);
	}
}

export interface ExportTemplateListModel {
	id: number;
	name: string;
	isUsedInAutomatic: boolean;
}

export interface ExportTemplateModel<ESM extends ExportSettingsModel> {
	id: number;
	name: string;
	outputType: ExportOutputType;
	settings: ESM;
}

export interface ExportSettingsModel {
	fieldCodes: string[];
}

export const enum ExportOutputType {
	Xml,
	Csv
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/export.service.ts